import React, { useState, useEffect, useRef }  from 'react';
import ToolTip from 'components/show_drawing/ToolTip.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import Constants from 'components/show_drawing/Constants.jsx';

const PrintingMethodChooser = ({ id, unit, drawing }) => {
  const [printingMethod, setPrintingMethod] = useState('offset')
  const labelRef = useRef();

  const emitLabelWidth = () => {
    if (labelRef.current) {
      emitEvent(Constants.drawing_input_label_width, { id: id, name: 'printing_method', width: $(labelRef.current).width(), group: 'dropdowns' });
    }
  };

  const adjustLabelWidthMsg = (e) => {
    if (e.detail.id == id && e.detail.name != 'printing_method' && e.detail.group == 'dropdowns' && labelRef.current) {
      let myWidth = $(labelRef.current).width();
      let othersWidth = e.detail.width;
      if (othersWidth > myWidth) {
        $(labelRef.current).width(othersWidth);
      }
    }
  };

  const onDrawingOptionValueSetMsg = (msg) => {
    if(msg.detail.id == id && msg.detail.name == 'printing_method') {
      emitEvent('addDebugEntry', { event: "[PrintingMethodChooser] printingMethod changed", name: msg.detail.name, value: msg.detail.value})
      if(printingMethod == msg.detail.value) { publishChangedEvent() }
      setPrintingMethod( () => msg.detail.value)
    }
  }

  const publishChangedEvent = () => {
    emitEvent(Constants.drawing_option_change_completed, {id: id, name: 'printing_method'})
    emitEvent('addDebugEntry', { event: "[PrintingMethodChooser] SetValue event emitted", id: id, name: 'printing_method', value: printingMethod} )
  }

  // useEffect
  useEffect(publishChangedEvent, [id, unit, drawing,printingMethod] )

  useEffect( () => { setPrintingMethod( () => 'offset' ) }, [id, unit, drawing])
  useEffect(emitLabelWidth, [labelRef.current])
  // useEffect

  MyEventListener([
    {
      key: Constants.drawing_option_set_value,
      callback: onDrawingOptionValueSetMsg
    },
    {
      key: Constants.drawing_input_label_width,
      callback: adjustLabelWidthMsg
    }
  ])

  return (
    <div className={styles.row}>
      <div className="input-group" style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={labelRef}>
          { t('drawing.printing_method') }
          <ToolTip title={t('drawing.help')} toolTipKey='offset' />
        </span>
        <select name="printing_method" value={printingMethod} onChange={(e) => setPrintingMethod(e.target.value)} className="form-control">
          <option value="offset"> {t('drawing.offset_printing')} </option>
          <option value="flexo"> {t('drawing.flexo_printing')} </option>
        </select>
      </div>
    </div>
  )
}

export default PrintingMethodChooser;
